type Props = {
  kicker: string;
  title: string;
  desc?: string;
  tone?: 'primary' | 'accent';
};

export default function SectionHeader({ kicker, title, desc, tone = 'primary' }: Props) {
  const dot = tone === 'accent' ? 'bg-accent-500' : 'bg-primary-500';
  const text = tone === 'accent' ? 'text-accent-700' : 'text-primary-700';
  return (
    <div className="mb-8 md:mb-10">
      <p className={`mb-3 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wide ${text}`}>
        <span className={`inline-block h-2 w-2 rounded-full ${dot}`} aria-hidden="true"></span>
        {kicker}
      </p>
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc ? <p className="max-w-xl text-sm leading-relaxed text-foreground-500">{desc}</p> : null}
      </div>
    </div>
  );
}